"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClinicsPage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var section_swapper_1 = require("../../components/section_swapper");
var measuring_blood_pressure_png_1 = __importDefault(require("../../assets/clinics/measuring_blood_pressure.png"));
var ClinicsPage = function (props) {
    var _a = props;
    (0, react_1.useEffect)(function () {
        //
    }, []);
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, null,
            react_1.default.createElement(section_swapper_1.SectionSwapperComponent, { imageSide: "left", image: measuring_blood_pressure_png_1.default, smallTitle: "HEALTH CARE", bigTitle: "Clinics.", 
                // buttonText="Learn More"
                description: "The Local Choice Franchise is an aligned, like-minded group of independent pharmacists, working together to help people get, feel and live better. Local Choice Pharmacies take the time to offer personal care to each patient and to make a positive difference to their daily lives.", content: [
                    {
                        title: "Trusted prices.",
                        description: "Our commitment to affordability. Local Choice pharmacies are committed to cost-effective and affordable pricing on medicine as well as other products, including vitamins, sports supplements and beauty products. View our promotions page to see which products are special. Local Choice pharmacies are registered as preferred suppliers for most medical aid schemes. Therefore, prescriptions are dispensed and paid for at the rate of the medical aid scheme. The pharmacies are following this as stipulated by the scheme.",
                    },
                    {
                        title: "Co-payments and script levies.",
                        description: "Most medical aid schemes have a preferred medicine list (formulary), which is a list of medication that is covered by your scheme only. To avoid co-payments and levies, patients are advised to familiarize themselves with their medical aid schemes formulary list and price rules. Ask your Local Choice pharmacist for advice on the best cost-effective options for you according to your medical aid scheme.",
                    },
                    {
                        title: "The pharmacist at each Local Choice Pharmacy is assisted by passionate and knowledgeable assistants who are continuously aiming to provide:",
                        list: [
                            "Quality medicines and related healthcare products",
                            "Professional and trusted medical advice",
                            "Personalised clinic services",
                            "Assistance with medical aid claims",
                        ],
                    },
                    {
                        title: "Your first point of entry to pharmaceutical advice and care. The pharmacist at your Local Choice Pharmacy:",
                        list: [
                            "Has links with local health professionals, e.g., GPs, to provide the best support to you",
                            "Provides general health advice and support with chronic disease management",
                            "Ensures the quality of the products sold at the pharmacy",
                            "Advises patients on the appropriate use, interactions and side effects of medication",
                            "Provides basic clinic services",
                            "Is informed of any health risks and/or warnings that the community should be aware of",
                            "A source of information on current medicines and health innovations",
                        ],
                    },
                ] }))));
};
exports.ClinicsPage = ClinicsPage;
